export default __webpack_public_path__ + "static/media/logo.9d5d422c.png";